import React from "react";

export default function NewLanding() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <header className="py-6 bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-blue-600">CallAI CRM</h1>
          <nav className="flex gap-6 text-sm font-medium">
            <a href="#features" className="hover:text-blue-600">Features</a>
            <a href="#pricing" className="hover:text-blue-600">Pricing</a>
            <a href="#testimonials" className="hover:text-blue-600">Testimonials</a>
            <a href="#contact" className="hover:text-blue-600">Contact</a>
          </nav>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-bold mb-6">
          🚀 AI-Powered Cold Calling for Real Estate Investors
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
          Scale your lead generation with intelligent AI voice agents that sound human,
          follow proven scripts, and convert property owners into motivated sellers.
        </p>
        <div className="flex justify-center gap-4">
          <button className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700">
            Start Free Trial
          </button>
          <button className="px-6 py-3 bg-gray-100 rounded-lg font-medium hover:bg-gray-200">
            Watch Demo
          </button>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} CallAI CRM. All rights reserved.
      </footer>
    </div>
  );
}
